class VariantChangeBannerImage {
  constructor(parent, data) {
    this.parent = parent;
    this.data = data;
    this.boundOnVariantChangeCustom = this.onVariantChangeCustom.bind(this);
    this.boundOnVariantIdChange = this.onVariantIdChange.bind(this);
  }

  updateBanner(variantId) {
    const imageWrapper = this.parent.querySelector('.image-wrapper');
    if (imageWrapper) {
      imageWrapper.setAttribute('data-initial-variant-id', variantId);
    }

    const variantData = this.data[variantId];
    const desktopUrl = variantData
      ? variantData.banner_image || variantData.banner_image_mobile
      : null;
    const desktopSrcset = variantData
      ? variantData.banner_image_srcset || variantData.banner_image_mobile_srcset
      : null;
    const mobileUrl = variantData
      ? variantData.banner_image_mobile || variantData.banner_image
      : null;
    const mobileSrcset = variantData
      ? variantData.banner_image_mobile_srcset || variantData.banner_image_srcset
      : null;

    if (!desktopUrl && !mobileUrl) {
      this.parent.classList.add('variant-banner-empty');
      return;
    }

    this.parent.classList.remove('variant-banner-empty');

    const imgDesktop = this.parent.querySelector('.image-desktop img');
    const imgMobile = this.parent.querySelector('.image-mobile img');
    const pictureDesktop = this.parent.querySelector('.image-desktop picture');
    const sourceMobile = pictureDesktop
      ? pictureDesktop.querySelector('source[media*="767px"]')
      : null;

    if (imgDesktop) {
      if (desktopUrl) imgDesktop.src = desktopUrl;
      if (desktopSrcset) {
        imgDesktop.srcset = desktopSrcset;
      } else {
        imgDesktop.removeAttribute('srcset');
      }
    }

    if (sourceMobile) {
      sourceMobile.srcset =
        mobileSrcset || (mobileUrl ? mobileUrl + ' 750w' : '');
    }

    if (imgMobile) {
      if (mobileUrl) imgMobile.src = mobileUrl;
      if (mobileSrcset) {
        imgMobile.srcset = mobileSrcset;
      } else {
        imgMobile.removeAttribute('srcset');
      }
    }
  }

  onVariantChangeCustom(e) {
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      this.updateBanner(String(e.detail.variant.id));
    }
  }

  onVariantIdChange(e) {
    const formId = e.target && e.target.form && e.target.form.id;
    if (
      e.target &&
      e.target.name === 'id' &&
      e.target.form &&
      String(formId || '').indexOf('product-form-') === 0 &&
      e.target.value
    ) {
      this.updateBanner(e.target.value);
    }
  }

  init() {
    const input = document.querySelector(
      'form[id^="product-form-"] input[name="id"]'
    );
    if (input && input.value) {
      this.updateBanner(input.value);
    }

    document.removeEventListener('variant-change', this.boundOnVariantChangeCustom);
    document.addEventListener('variant-change', this.boundOnVariantChangeCustom);

    document.body.removeEventListener('change', this.boundOnVariantIdChange);
    document.body.addEventListener('change', this.boundOnVariantIdChange);
  }

  destroy() {
    document.removeEventListener('variant-change', this.boundOnVariantChangeCustom);
    document.body.removeEventListener('change', this.boundOnVariantIdChange);
  }
}

function initVariantChangeBannerImages() {
  const wrappers = document.querySelectorAll(
    '.variant-change-banner-image-wrapper[data-variant-banner-section]'
  );

  wrappers.forEach((wrapper) => {
    const sectionId = wrapper.getAttribute('data-variant-banner-section');
    if (!sectionId) return;

    const scriptEl = document.querySelector(
      `script[data-variant-banners="${sectionId}"]`
    );
    if (!scriptEl) return;

    let data;
    try {
      data = JSON.parse(scriptEl.textContent);
    } catch (e) {
      return;
    }

    const instance = new VariantChangeBannerImage(wrapper, data);
    instance.init();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantChangeBannerImages);
} else {
  initVariantChangeBannerImages();
}
